<template>
  <div class="panel">
    <div class="title">
      <h4 class="indicator">
        {{ indicator.abbr }}
      </h4>
    </div>
    <div class="cf">
      <h4 class="location">{{ location }}</h4>
      <SPViewButtons
        v-if="!printerFriendly"
        :view="view"
        :instance="instance"
        class="fr"
        @changeView="changeView"
      />
    </div>
    <SPStratFilters
      :view="view"
      :instance="instance"
    />
  </div>
</template>

<style scoped>
  .panel {
    border: 1px solid #C0C0C0;
    margin: 10px 7.5px 15px;
    padding-bottom: 10px;
  }
  .panel:last-child {
    margin-bottom: 10px;
  }
  .title {
    background-color: rgb(242,242,242);
    display: table;
    width: 100%;
    border-spacing: 5px;
  }

  .location {
    display: inline-block;
    font-size: 16px;
    font-weight: bolder;
    padding-top: 10px;
    padding-left: 8px;
    margin: 0;
  }

  .indicator {
    font-size: 14px;
    font-weight: bolder;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 1px;
    padding-left: 5px;
  }

  .cf:before,
  .cf:after {
    content: " ";
    display: table;
  }

  .cf:after {
    clear: both;
  }

  .fr {
    float: right;
  }
</style>

<script>
import { mapState } from 'vuex';
import SPViewButtons from './SPViewButtons';
import SPStratFilters from './SPStratFilters';

export default {
  components: {
    SPViewButtons,
    SPStratFilters,
  },
  props: {
    instance: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      view: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('Chart', this.instance, 'view'),
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      indicators: state => state.SP.indicators,
      GSGo: state => state.SP.GSGo,
    }),
    indicator() {
      return this.indicators[this.instance];
    },
    indicatorsCsv() {
      return this.$store.getters['SP/indicatorsCsv'];
    },
    location() {
      return this.GSGo.location;
    },
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
  },
  watch: {
    indicatorsCsv() {
      this.view = 'Chart';
    },
  },
  methods: {
    changeView(newView) {
      this.view = newView;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/SP/SPPanel.vue